import { MutableRefObject } from "react";
import { Request } from "./mappers";

export const isRequestFullfilled = (request: MutableRefObject<Request | null>): request is MutableRefObject<Request> => {
    return request.current !== null;
}